export default {
  name: "virtualWrapper",
  inject: {
    $dsfElTable: {
      default: null
    }
  },
  props: {
    fixedPosition: {
      type: String,
      default: ""
    }
  },

  data() {
    return {};
  },
  computed: {
    fixedMark() {
      return this.table.getFixed(this.fixedPosition);
    },
    data() {
      return this.$dsfElTable.data;
    },
    table() {
      return this.$dsfElTable;
    },
    virtualScroll() {
      return this.$dsfElTable.virtualScroll;
    },
    showRangeData() {
      return this.$dsfElTable.showRangeData;
    },
  },
  created() {
    this.table.$on("virtual-scroll", this.updateTranslateY);
  },
  beforeDestroy() {
    const { useVirtulScroll, useShowRangeData } = this.table;
    if (this.fixedMark == "main" && (useVirtulScroll || useShowRangeData)) {
      dsf.event.removeMouseWheelEvent(this.$el, this.onMouseWheelHandler);
    }
    this.table.$off("virtual-scroll", this.updateTranslateY);
  },
  mounted() {
    const { useVirtulScroll, useShowRangeData } = this.table;
    if (this.fixedMark == "main" && (useVirtulScroll || useShowRangeData)) {
      dsf.event.addMouseWheelEvent(this.$el, this.onMouseWheelHandler);
    }
  },
  methods: {
    updateTranslateY() {
      this.$refs.box.style.transform = `translateY(${this.unitSize(this.table.$translateY)})`;
    },
    onMouseWheelHandler(event, {pixelY, pixelX}) {
      let k = this.virtualScroll || this.showRangeData ? 0.2 : 1;
      const { virtualBox, bodyWrapper } = (this.table || this).$refs;
      const scrollBox = virtualBox || bodyWrapper;
      const { scrollTop, scrollLeft, scrollHeight, scrollWidth, clientHeight, clientWidth } = scrollBox;
      if (!pixelY && !pixelX) return;
      if (event.shiftKey && !pixelX) {
        pixelX = pixelY;
        pixelY = 0;
      }
      if (Math.abs(pixelY) > Math.abs(pixelX)){
        if ((pixelY < 0 && scrollTop > 0) || (pixelY > 0 && scrollTop + clientHeight < scrollHeight)) {
          event.stopPropagation();
          // event.preventDefault();
        }
        scrollBox.scrollTop += Math.ceil(pixelY * k);
      } else {
        if ((pixelX < 0 && scrollLeft > 0) || (pixelX > 0 && scrollLeft + clientWidth < scrollWidth)) {
          event.stopPropagation();
          // event.preventDefault();
        }
        scrollBox.scrollLeft += Math.ceil(pixelX * k);
      }
    }
  },
  render(h) {
    let width = this.table.layout.bodyWidth;
    //标识表格横向撑满屏幕,但存在纵向滚动条
    if (this.table.layout.scrollY && !this.table.layout.scrollX) {
      width = this.table.layout.bodyWidth - this.table.layout.gutterWidth;
    }
    const { useVirtulScroll, useShowRangeData } = this.table;
    let height = useVirtulScroll || useShowRangeData ? this.table.scrollHeight : "auto";
    return (
      <div
        class="el-table__virtual-wrapper"
        style={{
          width: this.unitSize(width),
          height: this.unitSize(height)
        }}
      >
        <div ref="box" style={{ height: this.data.length <= 0 ? "100%" : "auto" }}>
          {this?.$scopedSlots?.default?.()}
        </div>
      </div>
    );
  }
};
